import DisablableHeaderActionButton from './DisablableHeaderActionButton'
import {
  UseCheckPermissionsMapItem,
  useCheckPermissionsMap,
} from 'hooks/useCheckPermission'
import { useCIMSTableContext } from '../../../CIMSTableContext'
import CIMSLink from '../../../../CIMSLink'

function CustomHeaderActionButtons<T extends object>() {
  const { dataSource, actions } = useCIMSTableContext<T>()
  const custom = actions.header.custom ?? []
  const [map] = useCheckPermissionsMap(
    custom.reduce((customs, custom, key) => {
      if (custom.type === 'externalLink') return customs
      const { permission } = custom
      if (typeof permission === 'function')
        customs.push({ key, permission, record: dataSource })
      else customs.push({ key, permission })
      return customs
    }, Array<UseCheckPermissionsMapItem<T, number>>())
  )
  return (
    <>
      {custom.map((custom, i) => {
        if (custom.type === 'externalLink') {
          const { type: _, label, ...rest } = custom
          return (
            <CIMSLink key={`externalLink-${i}`} external {...rest}>
              {label}
            </CIMSLink>
          )
        }
        const { text, onClick, permission: permissions, ...rest } = custom
        if (!map.get(i)) return null
        return (
          <DisablableHeaderActionButton
            key={`actionButton-${i}`}
            {...rest}
            callback={onClick}
          >
            {text}
          </DisablableHeaderActionButton>
        )
      })}
    </>
  )
}

export default CustomHeaderActionButtons
